import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import Logo from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { CheckCircle2 } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const lead = location.state?.lead;
  const [f, setF] = useState({
    first_name: lead?.first_name || "", last_name: lead?.last_name || "", email: lead?.email || "",
    phone: lead?.phone || "", practice: lead?.practice || "", city: lead?.city || "",
    canton: lead?.canton || "", password: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await register({ ...f, lead_id: lead?.lead_id });
      navigate("/espace");
    } catch (err) { setError(apiError(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 sm:p-12 bg-background">
      <div className="w-full max-w-lg">
        <Logo />
        <div className="mt-8 bg-white rounded-2xl border border-slate-200 p-6 md:p-8">
          <h1 className="font-heading font-bold text-2xl text-slate-900">Créer mon espace client</h1>
          <p className="mt-2 text-sm text-slate-500">Suivez vos demandes et communiquez avec notre équipe.</p>
          {lead && <div className="mt-4 flex items-center gap-2 text-sm text-emerald-700 bg-emerald-50 border border-emerald-100 rounded-lg p-3" data-testid="register-lead-linked"><CheckCircle2 className="h-4 w-4" />Votre demande sera automatiquement liée à votre compte.</div>}
          <form onSubmit={submit} className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div><Label>Prénom *</Label><Input value={f.first_name} onChange={(e) => set("first_name", e.target.value)} required className="mt-1" data-testid="register-firstname" /></div>
            <div><Label>Nom *</Label><Input value={f.last_name} onChange={(e) => set("last_name", e.target.value)} required className="mt-1" data-testid="register-lastname" /></div>
            <div className="sm:col-span-2"><Label>E-mail *</Label><Input type="email" value={f.email} onChange={(e) => set("email", e.target.value)} required className="mt-1" data-testid="register-email" /></div>
            <div><Label>Téléphone</Label><Input value={f.phone} onChange={(e) => set("phone", e.target.value)} className="mt-1" /></div>
            <div><Label>Cabinet</Label><Input value={f.practice} onChange={(e) => set("practice", e.target.value)} className="mt-1" /></div>
            <div><Label>Ville</Label><Input value={f.city} onChange={(e) => set("city", e.target.value)} className="mt-1" /></div>
            <div><Label>Canton</Label><Input value={f.canton} onChange={(e) => set("canton", e.target.value)} className="mt-1" /></div>
            <div className="sm:col-span-2"><Label>Mot de passe *</Label><Input type="password" value={f.password} onChange={(e) => set("password", e.target.value)} required minLength={6} className="mt-1" data-testid="register-password" /></div>
            {error && <p className="sm:col-span-2 text-sm text-rose-600" data-testid="register-error">{error}</p>}
            <Button type="submit" className="sm:col-span-2 bg-primary" disabled={loading} data-testid="register-submit">{loading ? "Création..." : "Créer mon compte"}</Button>
          </form>
          <p className="mt-6 text-sm text-slate-500 text-center">Déjà un compte ? <Link to="/connexion" className="text-primary font-medium">Se connecter</Link></p>
        </div>
      </div>
    </div>
  );
}
